import { Model } from './types';

export const APP_TITLE = "AI Marker Mate";
export const GEMINI_OCR_MODEL = "gemini-3.5-flash";
export const MARKING_PROMPT_VERSION = 'v1.0.0';

export const MODELS: { [key: string]: Model } = {
  'gemini-3.1-pro-preview': {
    id: 'gemini-3.1-pro-preview',
    name: 'Gemini 3.1 Pro',
    description: 'Google\'s most capable Gemini model, with advanced reasoning and standard thinking.',
    apiModel: 'gemini-3.1-pro-preview',
    version: 'v1.0.0',
    // NOTE: This app proxies via the Generative Language REST endpoint
    // `.../v1beta/models/{model}:generateContent`. Thinking runs at the model's
    // default ("standard") level; the `thinking_level` parameter is not sent.
    config: {}
  },
  'gpt-5.5': {
    id: 'gpt-5.5',
    name: 'ChatGPT (GPT-5.5)',
    description: 'OpenAI\'s latest frontier model for advanced reasoning and detailed analysis.',
    apiModel: 'gpt-5.5',
    version: 'v1.0.0',
    config: {}
  },
  'claude-sonnet-4-6': {
    id: 'claude-sonnet-4-6',
    name: 'Claude Sonnet 4.6',
    description: 'Anthropic\'s latest model balancing speed and intelligence for complex analysis.',
    apiModel: 'claude-sonnet-4-6',
    version: 'v1.0.0',
    config: {}
  }
};
export const DEFAULT_MODEL_ID = 'gemini-3.1-pro-preview';


export const NUMBER_OF_MARKING_RUNS = 1;

// Temperature for scoring runs should be low for stability and consistency.
export const GEMINI_SCORING_TEMPERATURE = 0.0;

// Temperature for feedback generation can be higher for richer, more creative prose.
export const GEMINI_FEEDBACK_TEMPERATURE = 0.6;

// Temperature for meta-analysis should be very low for deterministic, decisive output.
export const GEMINI_META_ANALYSIS_TEMPERATURE = 0.0;

export const ADMIN_USER_EMAILS = ['nick.hull.42@gmail.com'];

export const DEFAULT_SYSTEM_INSTRUCTIONS = `# Context for judging structure
* You do not care so much about spelling errors or grammatical issues
* You are more focused on their being a clear structure in terms of an intro, clear paragraphs which have a logical flow and that the structure is sustained.

EVALUATION PROCEDURE

Systematic Checklist:
1. Explicitly assess each rubric criterion
2. Pick one of the bands (or score range) for each criterion that you feel best fits the essay, based on the user's specific rubric.
3. Cite specific references from the essay to justify your assessment for each criterion.`;

export const QUOTA_EXCEEDED_USER_MESSAGE = "The AI service has reached its request limit or your quota has been exceeded. Please wait a while before trying again, or check your API plan and billing details. If the problem persists, contact support.";
